export default {
  favorites: 'Favorites',
  recommend: 'Recommend',
  zoom_play: 'Zoom & Play',
  no_favorites_yet: 'No favorites yet',
  failed_to_load: 'Failed to load game',
  loading_game: 'Loading game…',
  unknown_error: 'Unknown error',
  default_tab_label: 'Live Casino',
  exit_game: 'Exit game',
  enter_game: 'Enter game',
  select_provider: 'Select provider',
  no_providers: 'No providers',
  no_games_found: 'No games found',
  game_maintenance: 'Maintenance',
  not_available: 'Not available',
  all_games_displayed: 'All games are displayed',
  failed_to_load_details: 'Failed to load game details',
  added_to_favorites: 'Added to favorites',
  removed_from_favorites: 'Removed from favorites',

  // Hash game shared strings
  odd: 'Odd',
  even: 'Even',
  big: 'Big',
  small: 'Small',
  banker: 'Banker',
  player: 'Player',
  tie: 'Tie',
  auto_bet: 'Auto Bet',

  hash_balance: 'Balance',
  hash_deposit: 'Deposit',
  hash_current_block: 'Current',
  hash_draw_block: 'Draw',
  hash_next_block: 'Next',
  hash_countdown: 'Time left',
  hash_recent_results: 'Recent results',
  hash_pick_side: 'Pick a side',
  hash_auto_bet_info: 'Auto bet — outcome decided by block hash',
  hash_beginner: 'Beginner',
  hash_intermediate: 'Intermediate',
  hash_min: 'Min',
  hash_max: 'Max',
  hash_payout: 'Payout',
  hash_amount_placeholder: 'Bet amount',
  hash_place_bet: 'Place Bet',
  hash_my_bets: 'My bets',
  hash_no_bets: 'No bets yet',
  bet_placed: 'Bet placed',
  bet_failed: 'Bet failed',
  invalid_amount: 'Invalid amount',
  insufficient_balance: 'Insufficient balance',

  // Banker / chip-rack UI
  hash_instant: 'Instant',
  hash_undo: 'Undo',
  hash_clear: 'Clear',
  hash_confirm: 'Confirm',
  hash_total: 'Total',
  hash_pick_chip_first: 'Place a chip first',
  hash_block: 'Block',
  hash_hash: 'Hash',
  hash_result: 'Result',
  hash_verify: 'Verify',
  hash_guide: 'How to Play',

  // Lucky Hash auto-bet labels + bet-result modal
  hash_win: 'Win',
  hash_loss: 'Loss',
  hash_won: 'You won',
  hash_lost: 'Better luck next time',
  hash_winnings: 'Winnings',
  hash_bet_amount: 'Bet amount',
  hash_close: 'Close',

  // Recent-results grid headers
  hash_history: 'History',
  hash_pattern: 'Pattern',

  // Hash guide sheet — game rules (BankerGameView guide)
  hash_rule_intro_1: 'For each of your bets, the system uses the block hash of the winning block as the lottery result.',
  hash_rule_intro_2: 'The last 5 digits of the winning block hash become the card face. For example, block hash 000***a3b78 produces card face a3b78.',
  hash_rules_heading: 'Game Rules',
  hash_rule_digits: "The banker's card face is the first 2 digits and the player's is the last 2. 0 is the smallest, 9 is the largest, and letters (a, b, c, …) count as 0.",
  hash_rule_example_letter: 'If the banker shows a, 3, the value is 3.',
  hash_rule_example_sum: 'If the banker shows 7, 8, the value is 5 (last digit of the sum).',
  hash_rule_banker_payout: 'Bet on Banker win — after comparing points, if the banker wins, it pays {odds}×.',
  hash_rule_player_payout: 'Bet on Player win — after comparing points, if the player wins, it pays {odds}×.',
  hash_rule_tie_payout: 'Bet on Tie — if it is a tie, it pays 8×.',
  hash_rule_tie_refund: 'If you bet on banker or player and the result is a tie, the bet is refunded after deducting a 50% service fee.',
  hash_attention_heading: 'Matters Needing Attention',
  hash_attention_tron_delay: "Due to TRON's ~3-second block refresh rate, transfers may incur some network delay. Your current bet will be settled against the confirmed bet-order block.",
}
